import * as types from '../../../actions';

const initialState = {
    items: [],
    status:0,
    item:{
      id:'',
      locationName:'',
      streetOne:'',
      streetTwo:'',
      city:'',
      state:'',
      country:'',
      postcode:''
    },
    activity:'',
    masterLocations:[],
    count:'',  
    errorData:''
};

export default function(state = initialState, action) {
  const response = action.response;
  switch(action.type) {

      case types.KEY_LOCATION_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: response.data,
                    status: response.status,
                    activity:types.KEY_LOCATION_LIST_SUCCESS,  
                    count:response.data.count        
                };
            }else{
                return {
                    ...state,
                    status: response.status,    
                    activity:types.KEY_LOCATION_LIST_ERROR,                             
                };
            }  

        case types.KEY_LOCATION_ADD_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: [...state.items],
                    status: response.status,
                    activity:types.KEY_LOCATION_ADD_SUCCESS,
                }
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.KEY_LOCATION_ADD_ERROR,
                    errorData: response.data,
                }
            }
        case types.KEY_LOCATION_DELETE_SUCCESS:
            const id = response.data.id;   
            if(response.status===200){             
                return {
                    ...state,
                    items: state.items.filter(items => items.id !== id),                
                    status: response.status,
                    activity:types.KEY_LOCATION_DELETE_SUCCESS,   
                }
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.KEY_LOCATION_DELETE_ERROR,  
                    errorData: response.data, 
                }
            }
        case types.MASTER_LOCATION_LIST_SUCCESS:
            return {
                ...state,
                status:response.status,
                masterLocations:response.data,
                activity:types.MASTER_LOCATION_LIST_SUCCESS,
            }           
              
        case types.CLEAR:
            return {
                ...state,
                item:{
                    id:'',
                    locationName:'',
                    streetOne:'',
                    streetTwo:'',
                    city:'',
                    state:'',
                    country:'',
                    postcode:''
                },
                activity:types.CLEAR,
                status:0               
           }  

        default:
          return state;
  }
};